<template>
  <div class="pt-5" style="text-align: center">
    <div v-if="error">エラーが発生しました。</div>
    <vue-simple-spinner message="Redirect..." v-else />
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import VueSimpleSpinner from 'vue-simple-spinner';
import Config from '@/config';

export default {
  name: 'RippleLogin-new',
  components: { VueSimpleSpinner },
  created() {
    // this.$store.commit('RESET_VUEX_STATE');
    this.authenticate();
  },
  data() {
    return {
      error: false,
    };
  },
  methods: {
    ...mapActions('auth', {
      getAccessToken: 'getAccessToken',
    }),

    ...mapMutations({
      updateWaveForResellerMeta: 'updateWaveForResellerMeta',
    }),

    async authenticate() {
      try {
        const params = this.checkParams();
        const token = await this.getAccessToken(params);
        await this.setTokenCookie(token);
        await this.$root.loadInitialData('login');
      } catch (e) {
        this.error = true;
      }
    },

    setTokenCookie(token) {
      Cookies.set('mo_wave_for_reseller_access_token', token, {
        expires: Config.tokenExpire,
        path: Config.cookiePath,
      });

      return Promise.resolve();
    },

    checkParams() {
      const param = decodeURIComponent(location.search);

      const slice_param = param.slice(1);
      const split_param = slice_param.split('&');
      const param1 = split_param[0].split('=');
      const param2 = split_param[1].split('=');
      const param3 = split_param[2].split('=');

      const username = atob(param1[1]);

      const password_text = atob(param2[1]);
      const obj_json = JSON.parse(password_text);

      const encrypted = obj_json.ciphertext;
      const salt = CryptoJS.enc.Hex.parse(obj_json.salt);
      const iv = CryptoJS.enc.Hex.parse(obj_json.iv);

      const key = CryptoJS.PBKDF2('k4ewn6GR#byN8qTA', salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: 64 / 8,
        iterations: 999,
      });

      const decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv }).toString(
        CryptoJS.enc.Utf8
      );

      // Wave for Resellerのmeta情報をCookieに保存
      Cookies.set(`wave_for_reseller_meta_${username}`, param3[1], { expires: Config.tokenExpire });

      return {
        username: username,
        password: decrypted,
        grantType: 'password',
      };
    },
  },
};
</script>
